resourcePaths = '{"rootPath":"","assetsPath":""}';/*
    SchemaValidation

    Validates a form based on given validation schema(s). This validation should be used across
    all forms. More information on validation schemas can be found at http://json-schema.org/
    This framework validates a form and invokes the display of pertinent error messaging. This
    component must be created/initialized on a HTML Form element.

    Arguments:
        schema (required) [object]:
            JSON Validation schema consisting of rules for validation. See http://json-schema.org/
            for format.
        validationObj (optional) [object]:
            Object consisting of additional rules for validation - including data sanitization,
            conditional validation, and custom error messaging. See below for format.
            **DEPRECATED, use hooks** onUpdateValidation (optional) [function]:
            Callback function for when the form is updated.
        onSubmit (optional) [function]:
            Callback function for when the form is submitted.

    validationObj [object] format:
    {
        _hooks: {
            [prehook (function)],
            [posthook (function)]
        },
        <field_name>: {
            [sanitize (function)],
            [conditional (function)],
            [conditionalReset (boolean | false)],
            [error (string | object)]
        },
        ...
    }

    errorObj [object] format:
    {
        default (optional) [string],
        <key_name> (optional) [string],
        ...
    }
*/
function SchemaValidation () {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.priority = 2500; // Executes later than page priority
  this.extends = [];

  this.schema = null;
  this.onUpdateValidation = null; /* DEPRECATED, use hooks */
  this.onSubmit = function (results) {};
  this.disableTypeConversion = false;

  this.validationObj = {};
  this._schemas = {};
  this._defaultSchemaId = null;
  this._initialized = false;
  this._resultObj = null;
  this._ajv = null;
  this._schemaIdGenerator = -1;
  this._eventMap = {};
  this._buttonsArr = [];
  this._validationIncludePaths = {};
  this._validationExcludePaths = {};
  this.fieldErrors = null;

  this.analyticsEvents = {
    'form-errors': {
      FormErrors: function (errorFieldList) {
        return errorFieldList;
      },
      event: 'DLevent.FormErrors'
    },
    'form-abandoned-schema': {
      FormAbandoned: function (fieldsInteractedWith) {
        return fieldsInteractedWith
          .map(function (elem) {
            return elem.name;
          })
          .join(',');
      },
      event: 'DLevent.FormExit'
    }
  };
  this.analytics = new Analytics();
  this.analytics.extendEventObject(this.analyticsEvents);

  this.init = function () {
    this._disableButtons();
    $(this.node).show();

    if (this.node.tagName.toLowerCase() != 'form') {
      console.error('SchemaValidation: requires a FORM node');
      return;
    }

    // Submit event handler
    $(this.node).on('submit', $.proxy(this._onSubmitForm, this));

    // Check for ajv
    if (typeof Ajv !== 'function') {
      this._retrieveAjv();
    }
  };

  this.initAllReady = function () {
    this._initialized = true;
    if (typeof Ajv === 'function') {
      this._initSchemaValidation();
    }

    // DL Abandoned Form Report
    $(window).on('beforeunload.validation', this._onFormAbandonment.bind(this));
  };

  this._initSchemaValidation = function () {
    // Setup ajv
    this._ajv = new Ajv({
      coerceTypes: !this.disableTypeConversion,
      allErrors: true,
      verbose: true,
      errorDataPath: 'property'
    });

    // Add schema
    if (this.schema) this._defaultSchemaId = this.addSchema(this.schema);

    // Initialize result object
    this._initializeResultObj();

    // Setup event handlers
    this._initializeFieldEventHandlers();

    this._enableButtons();
  };

  /*
        Adds a schema for validation, can be used for reference schemas. The first schema
        added is set as the default schema.

        Arguments:
            schema [object]:
                A JSON validation schema.

        Returns:
            [integer]
                A reference ID for the added schema.
    */
  this.addSchema = function (schema) {
    try {
      var schemaId = ++this._schemaIdGenerator + '';
      this._ajv.addSchema(schema, schemaId);
      this._schemas[schemaId] = schema;
      if (Object.keys(this._schemas).length == 1) this._defaultSchemaId = schemaId;
      return schemaId;
    } catch (e) {
      console.error('SchemaValidation: Error adding schema', e);
      return null;
    }
  };

  /*
        Removes a schema from validation.

        Arguments:
            schemaId [integer]:
                The schemaId referencing the schema to be removed.

        Returns:
            [boolean]
                true if successful, false otherwise.
    */
  this.removeSchema = function (schemaId) {
    try {
      schemaId = schemaId + '';
      this._ajv.removeSchema(schemaId);
      delete this._schemas[schemaId];
      if (schemaId == this._defaultSchemaId) this._defaultSchemaId = null;
      return true;
    } catch (e) {
      console.error('SchemaValidation: Error removing schema');
      return false;
    }
  };

  /*
        Adds an inclusion path. Only validate within this path.

        Arguments:
            path [string]:
                The JSON-pointer as a URI fragment (RFC6901). Eg. #/oneOf/3
            force [boolean]:
                Forces removal of existing exclusion paths and add this to the list of
                inclusion paths. Defaults to false.

        Returns:
            [boolean]
                true if successful, false otherwise.
    */
  this.addValidationIncludePath = function (path, force) {
    if (typeof path !== 'string') return false;
    if (!force && Object.keys(this._validationExcludePaths).length > 0) return false;
    else if (force) this._validationExcludePaths = {};

    this._validationIncludePaths[path] = true;
    return true;
  };

  /*
        Adds an exclusion path. Only validate outside of this path.

        Arguments:
            path [string]:
                The JSON-pointer as a URI fragment (RFC6901). Eg. #/oneOf/3
            force [boolean]:
                Forces removal of existing inclusion paths and add this to the list of
                exclusion paths. Defaults to false.

        Returns:
            [boolean]
                true if successful, false otherwise.
    */
  this.addValidationExcludePath = function (path, force) {
    if (typeof path !== 'string') return false;
    if (!force && Object.keys(this._validationIncludePaths).length > 0) return false;
    else if (force) this._validationIncludePaths = {};

    this._validationExcludePaths[path] = true;
    return true;
  };

  /*
        Removes an inclusion path.

        Arugments:
            path [string]:
                The JSON-pointer as a URI fragment (RFC6901). Eg. #/oneOf/3
    */
  this.removeValidationIncludePath = function (path) {
    if (typeof path !== 'string') return false;
    if (this._validationIncludePaths[path]) {
      delete this._validationIncludePaths[path];
      return true;
    }
    return false;
  };

  /*
        Removes an exclusion path.

        Arugments:
            path [string]:
                The JSON-pointer as a URI fragment (RFC6901). Eg. #/oneOf/3
    */
  this.removeValidationExcludePath = function (path) {
    if (typeof path !== 'string') return false;
    if (this._validationExcludePaths[path]) {
      delete this._validationExcludePaths[path];
      return true;
    }
    return false;
  };

  /*
        Removes all validation (inclusion and exclusion) paths.
    */
  this.removeAllValidationPaths = function () {
    this._validationIncludePaths = {};
    this._validationExcludePaths = {};
  };

  /*
        Retrieves the validation include and exclude paths.

        Returns:
            [object]
                An object consisting of the include and exclude paths;
    */
  this.getValidationPaths = function () {
    return {
      validationIncludePaths: this._validationIncludePaths,
      validationExcludePaths: this._validationExcludePaths
    };
  };

  this._checkPath = function (path) {
    if (Object.keys(this._validationIncludePaths).length > 0) {
      for (var key in this._validationIncludePaths) {
        if (path.indexOf(key) == 0) return true;
      }
      return false;
    } else if (Object.keys(this._validationExcludePaths).length > 0) {
      for (var key in this._validationExcludePaths) {
        if (path.indexOf(key) == 0) return false;
      }
    }
    return true;
  };

  /*
        Runs validation on a given set of data using a specified schema.

        Arguments:
            data [object] (required):
                The data to be validated.
            fieldArr [Array] (optional):
                The fields to be validated against. If not given, validates all fields.
            schemaId [integer] (optional):
                The validation schema to validate the data against. If not given,
                uses the default schema.
    */
  this.validate = function (data, fieldArr, schemaId) {
    if (!this._initialized) return;

    if (
      this.validationObj['_hooks'] &&
      typeof this.validationObj['_hooks'].prehook === 'function'
    ) {
      this.validationObj['_hooks'].prehook();
    }
    var schemaToUse = schemaId || this._defaultSchemaId;
    if (schemaToUse) {
      schemaToUse = schemaToUse + '';
      if ($(this.node).data('cleanup') === true) this._cleanup(data);
      var result = this._ajv.validate(schemaToUse, data);
      this._updateResultObject(result, fieldArr || Object.keys(this._resultObj._resultObj));

      this._updateFormErrors(fieldArr || Object.keys(this._resultObj._resultObj));
    }

    // Callback
    if (
      this.validationObj['_hooks'] &&
      typeof this.validationObj['_hooks'].posthook === 'function'
    ) {
      this.validationObj['_hooks'].posthook(this._resultObj);
    }
    if (typeof this.onUpdateValidation === 'function') {
      console.warn('onUpdateValidation callback is deprecated, use posthook instead');
      this.onUpdateValidation(this._resultObj);
    }
  };

  /*
       Runs validation on the response data of an action.

       Arguments:
           data [object] (required):
               The data to be validated.
   */
  this.validateResponse = function (node, data) {
    if (data.errors) {
      this.fieldErrors = data.errors;
      if (this.fieldErrors.length) {
        this.fieldErrors.forEach(function (err, index) {
          var fieldElement = $("[name='" + err.property + "']", this.node);
          if (fieldElement.length > 0) {
            fieldElement.mogo().setErrorOnKeyword(err.key);
            if (index == this.fieldErrors.length - 1) {
              this._resultObj.currentError = err.property;
              this._resultObj.count++;
              if (this._resultObj._resultObj[err.property]) this._resultObj._resultObj[err.property].error = true;
              fieldElement.mogo().showErrorLabel();
            }
          }
        }.bind(this));
      }
    } else {
      this.fieldErrors = null;
    }
  };

  /*
     Register the validation error in the result object and display error label on UI.
     Call this function when backend response does not have the correct error property
     to map to a form field.

     Arguments:
       targetFieldName [string] (required):
           The name of the field that will show the error label.
       errorMessage [string] (required):
           The error message to display.
   */
  this.setErrorForValidationField = function (targetFieldName, errorMessage) {
    var $field = $("[name='" + targetFieldName + "']", this.node).first();
    if ($field.mogo().declaredClass) {
      this._resultObj.currentError = targetFieldName;
      this._resultObj.count++;
      if (this._resultObj._resultObj[targetFieldName]) this._resultObj._resultObj[targetFieldName].error = true;
      $field.mogo().showErrorLabel(true, errorMessage);
    }
  };

  /*
    Clears the validation error from the result object and from the UI
  */
  this.resetValidationField = function (targetFieldName) {
    var fields = Object.keys($(this.node).serializeFormToObj(false));
    for (var i = 0; i < fields.length; i++) {
      var $field = $("[name='" + fields[i] + "']", this.node).first();
      var fieldName = $field.attr('name');
      if (fieldName == targetFieldName && this._resultObj._resultObj[fieldName]) {
        if (this._resultObj.currentError == targetFieldName) {
          this._resultObj.count = Math.max(this._resultObj.count - 1, 0);
          this._resultObj.currentError = null;
        }
        $field.mogo().hideError();
        this._resultObj._resultObj[fieldName] = {};
        this._resultObj._resultObj[fieldName].instance = $field;
        this._resultObj._resultObj[fieldName].position = this._getPosition($field);
        this._resultObj._resultObj[fieldName].data = $field.val();
        this._resultObj._resultObj[fieldName].error = false;
        this._resultObj._resultObj[fieldName].touched = false;
        this._resultObj._resultObj[fieldName].dirty = false;
        this._resultObj._resultObj[fieldName].resultDetails = {};
      } else {
        if (!this._resultObj.currentError &&
          this._resultObj.count &&
          this._resultObj._resultObj[fieldName].error) {
          this._resultObj.currentError = fieldName;
        }
      }
    }
  };

  // Recursive Helper Method to Cleanup an Object
  this._cleanup = function (inner) {
    $.each(
      inner,
      function (key, val) {
        if (typeof val === 'undefined') {
          delete inner[key];
        } else if (typeof val === 'object') {
          this._cleanup(val);
        }
      }.bind(this)
    );
  };

  this._initializeResultObj = function () {
    // Initialize result object
    this._resultObj = {};
    this._resultObj.count = 0;
    this._resultObj.currentError = null;
    this._resultObj._resultObj = {};
    var fields = Object.keys($(this.node).serializeFormToObj(false));
    for (var i = 0; i < fields.length; i++) {
      var $field = $("[name='" + fields[i] + "']", this.node).first();
      var fieldName = $field.attr('name');
      this._resultObj._resultObj[fieldName] = {};
      this._resultObj._resultObj[fieldName].instance = $field;
      this._resultObj._resultObj[fieldName].position = this._getPosition($field);
      this._resultObj._resultObj[fieldName].data = $field.val();
      this._resultObj._resultObj[fieldName].error = false;
      this._resultObj._resultObj[fieldName].touched = false; /* user has interacted with the form */
      this._resultObj._resultObj[
        fieldName
      ].dirty = false; /* user has interacted by entering data */
      this._resultObj._resultObj[fieldName].resultDetails = {};
    }
  };

  this._updateResultObject = function (ajvResult, fieldArr) {
    var resultObj = {};
    if (typeof fieldArr === 'undefined') fieldArr = [];
    var fieldHash = fieldArr.reduce(function (hash, elem, index) {
      hash[elem] = index++;
      return hash;
    }, {});
    if (!ajvResult) {
      var errorCount = 0;
      for (var i = 0; i < this._ajv.errors.length; i++) {
        var field = this._ajv.errors[i];
        var fieldName = field.dataPath.substr(1, field.dataPath.length);
        if (fieldName.length < 1) continue;
        // Check inclusion/exclusion paths
        if (field.schemaPath == null || this._checkPath(field.schemaPath)) {
          resultObj[fieldName] = {};
          resultObj[fieldName].result = false;
          resultObj[fieldName].resultDetails = {};
          resultObj[fieldName].resultDetails.data = field.data;
          resultObj[fieldName].resultDetails.keyword = field.keyword;
          resultObj[fieldName].resultDetails.message = field.message;
          resultObj[fieldName].resultDetails.schema = field.schema;
          resultObj[fieldName].resultDetails.parentSchema = field.parentSchema;
          resultObj[fieldName].resultDetails.schemaPath = field.schemaPath;
        }
      }
      for (var key in this._resultObj._resultObj) {
        this._resultObj._resultObj[key].data = this._getResultObjDataFor(key);
        // Check conditional
        var conditional = true;
        var conditionalReset = false;
        if (
          this.validationObj[key] != null &&
          this.validationObj[key].conditional &&
          typeof this.validationObj[key].conditional === 'function'
        ) {
          conditional = this.validationObj[key].conditional(this._resultObj._resultObj[key].data);
          if (this.validationObj[key].conditionalReset) {
            conditionalReset = true;
          }
        }

        /* resultObj update conditions (primary):
                  - conditional function returns true or function doesn't exist
                */
        if (conditional) {
          /* resultObj update conditions (secondary):
                   -   If fieldArr has fields, we update resultObj for fields in fieldArr &
                   for fields that already have been interacted with with data.
                   -   If fieldArr does not have fields, we update resultObj for all fields.
                   */
          if (
            (typeof resultObj[key] !== 'undefined' &&
              (fieldArr.length > 0 &&
                (key in fieldHash ||
                  (this._resultObj._resultObj[key].dirty === true ||
                    this._resultObj.submitted)))) ||
            (typeof resultObj[key] !== 'undefined' && fieldArr.length === 0)
          ) {
            errorCount++;
            this._resultObj._resultObj[key].error = true;
            this._resultObj._resultObj[key].result = false;
            this._resultObj._resultObj[key].resultDetails = resultObj[key].resultDetails;
          } else {
            this._resetResultObjFor(key);
          }
        } else if (conditionalReset) {
          this._resetResultObjFor(key);
        }
      }
      this._resultObj.count = errorCount;
    } else {
      this._resultObj.count = 0;
      for (var key in this._resultObj._resultObj) {
        this._resetResultObjFor(key);
      }
    }
    this._updateCurrentError();

    if (this._resultObj.count === 0 && this._ajv.errors && this._ajv.errors.length > 0) {
      var parameterList = [];
      for (var i = 0; i < this._ajv.errors.length; i++) {
        var field = this._ajv.errors[i];
        var fieldName = this._getFieldNameFromDataPath(field);
        // Missing parameter - fieldname should be in result object
        if (
          fieldName != null &&
          !this._resultObj._resultObj[fieldName] &&
          this._checkPath(field.schemaPath)
        ) {
          parameterList.push(fieldName);
        }
      }
      if (parameterList.length > 0) {
        throw new TypeError(
          'SchemaValidation.js missing one or more parameters: ' + parameterList.join(', ')
        );
      }
    }
    // console.log(this._ajv.errors);
    // console.log(this._resultObj._resultObj);
  };

  this._getFieldNameFromDataPath = function (ajvFieldObject) {
    var dataPath = ajvFieldObject.dataPath;
    var additionalPropertiesRe = /^\['(\w+)']$/g; // Format ['property_name']
    var fieldName = null;
    if (dataPath.trim() !== '') {
      if (dataPath.indexOf('.') === 0) {
        fieldName = dataPath.substr(1, dataPath.length);
      } else if (additionalPropertiesRe.exec(dataPath) != null) {
        // Additional properties mapping
      } else {
        console.warn('Unknown dataPath pattern: ' + dataPath);
      }
    }
    return fieldName;
  };

  this._resetResultObjFor = function (key) {
    this._resultObj._resultObj[key].data = this._getResultObjDataFor(key);
    this._resultObj._resultObj[key].error = false;
    this._resultObj._resultObj[key].result = true;
    this._resultObj._resultObj[key].message = '';
    this._resultObj._resultObj[key].schema = '';
    this._resultObj._resultObj[key].parentSchema = {};
    this._resultObj._resultObj[key].resultDetails = {};
  };

  this._getResultObjDataFor = function (key) {
    var data = this._retrieveValueFromField(key, !this.disableTypeConversion);
    if (this.validationObj[key] && typeof this.validationObj[key].sanitize === 'function') {
      data = this.validationObj[key].sanitize(data);
    }
    return data;
  };

  this._updateCurrentError = function (errorKeys) {
    var erroredFields = [];
    for (var field in this._resultObj._resultObj) {
      this._resultObj._resultObj[field].position = this._getPosition(
        this._resultObj._resultObj[field].instance
      );
      if (this._resultObj._resultObj[field].error) {
        erroredFields.push(this._resultObj._resultObj[field]);
      }
    }
    if (erroredFields.length === 0) {
      this._resultObj.currentError = '';
      return;
    }
    erroredFields.sort(function (a, b) {
      if (a.position.Y == b.position.Y) return a.position.X - b.position.X;
      return a.position.Y - b.position.Y;
    });

    // Get current error
    for (var i = 0; i < erroredFields.length; i++) {
      var erroredField = erroredFields[i];
      if (erroredField.position.X !== 0 && erroredField.position.Y !== 0) {
        if (erroredField.instance.attr('type') != 'hidden') {
          this._resultObj.currentError = erroredField.instance.attr('name');
          break;
        }
      }
    }
  };

  this._updateFormErrors = function (fieldArr) {
    var errorFieldList = [];
    for (var i = 0; i < fieldArr.length; i++) {
      var fieldComp = $("[name='" + fieldArr[i] + "']", this.node).mogo();
      if (this._isMogoUIComponent(fieldComp)) {
        if (this._resultObj.currentError == fieldArr[i]) {
          fieldComp.setErrorOnKeyword(this._resultObj._resultObj[this._resultObj.currentError].resultDetails.keyword);
        }
        if (this._resultObj._resultObj[fieldArr[i]].error) {
          fieldComp.showError();
          errorFieldList.push(fieldArr[i]);
        } else {
          fieldComp.hideError();
        }
      } else {
        // Native form fields
      }
    }
    if (errorFieldList.length > 0) {
      this.analytics.forcePushEvent('form-errors', {FormErrors: [errorFieldList.join(',')]});
    }
  };

  /*
     Consolidates multiple simultaneously occurring events (change/blur/focus/submit)
     and handles them as an atomic event.
     */
  this._pushToEventMap = function (event, fieldName) {
    if (event == 'submit') {
      this._eventMap['submit'] = true;
    } else {
      if (this._eventMap[event]) {
        this._eventMap[event].push(fieldName);
      } else {
        this._eventMap[event] = [fieldName];
      }
    }

    if (Object.keys(this._eventMap).length == 1) {
      setTimeout($.proxy(this._processEventMap, this), 80);
    }
  };

  /*
     Processes the event map to determine which error labels should be shown/hidden.
     Is not responsible for showing/hiding field errors (vs. field error labels).
     */
  this._processEventMap = function () {
    // console.log(this._eventMap);

    // Blur and focus events are not the same
    if (
      !(
        this._eventMap['blur'] != null &&
        this._eventMap['focus'] != null &&
        this._eventMap['blur'].length == 1 &&
        this._eventMap['focus'].length == 1 &&
        this._eventMap['blur'][0] == this._eventMap['focus'][0]
      )
    ) {
      if (this._eventMap['focus'] && !this._eventMap['submit']) {
        var focusElem = this._eventMap['focus'][this._eventMap['focus'].length - 1];

        // Show focused element error
        if (this._resultObj._resultObj[focusElem].error) {
          // Hide current error
          if (this._resultObj.submitted && focusElem != this._resultObj.currentError) {
            $("[name='" + this._resultObj.currentError + "']", this.node)
              .mogo()
              .hideErrorLabel();
          }

          $("[name='" + focusElem + "']", this.node)
            .mogo()
            .showErrorLabel();
        }
      }

      // Handle blur event
      if (this._eventMap['blur']) {
        for (var i = 0; i < this._eventMap['blur'].length; i++) {
          var blurElem = this._eventMap['blur'][i];
          if (
            this._isMogoUIComponent(blurElem) &&
            // Form submitted but current error is not the blurred element
            (!(this._resultObj.submitted && this._resultObj.currentError == blurElem) ||
              // The next focused element is an error element
              (this._eventMap['focus'] &&
                this._resultObj._resultObj[
                  this._eventMap['focus'][this._eventMap['focus'].length - 1]
                ].error))
          ) {
            $("[name='" + blurElem + "']", this.node)
              .mogo()
              .hideErrorLabel();
          }
        }

        if (
          (!this._eventMap['focus'] ||
            !this._resultObj._resultObj[this._eventMap['focus'][this._eventMap['focus'].length - 1]]
              .error) &&
          this._resultObj.submitted &&
          this._resultObj.currentError
        ) {
          for (var key in this._resultObj._resultObj) {
            if (key != this._resultObj.currentError && this._isMogoUIComponent(key)) {
              $("[name='" + key + "']", this.node)
                .mogo()
                .hideErrorLabel();
            }
          }
          if ($("[name='" + this._resultObj.currentError + "']", this.node).length) {
            $("[name='" + this._resultObj.currentError + "']", this.node)
              .mogo()
              .showErrorLabel();
          }
        }
      }
    }

    // Change event without blur event
    if (this._eventMap['change'] && !this._eventMap['blur'] && this._resultObj.submitted) {
      if (this._isMogoUIComponent(this._resultObj.currentError)) {
        $("[name='" + this._resultObj.currentError + "']", this.node)
          .mogo()
          .showErrorLabel();
      }
    }

    // Submit event
    if (this._eventMap['submit']) {
      // Handle submit events triggered by pressing enter key
      // when the focused field displays an error label
      // but it's not equal to the _resultObj.currentError field.
      var activeElem = $(document.activeElement);
      if ((Object.keys(this._eventMap).length == 1 ||
          (Object.keys(this._eventMap).length == 2 && this._eventMap['change'])
        ) &&
        this._resultObj.currentError &&
        typeof activeElem.mogo().hideErrorLabel == 'function' &&
        this._resultObj.currentError != activeElem.attr('name')) {
        activeElem.mogo().hideErrorLabel();
      }
      // Scroll up and show current error
      this._scrollTo(this._resultObj.currentError);
    }

    // Clear event map
    this._eventMap = {};
  };

  this._initializeFieldEventHandlers = function () {
    if (this._resultObj._resultObj) {
      for (var key in this._resultObj._resultObj) {
        var elemName = $(this._resultObj._resultObj[key].instance).attr('name');
        var elems = $("[name='" + elemName + "']", this.node);
        for (var i = 0; i < elems.length; i++) {
          var elem = elems[i];

          // Focus and blur handlers
          if (
            this._isMogoUIComponent(elem) &&
            ($(elem).mogo() instanceof BooleanGroup || $(elem).mogo() instanceof Select)
          ) {
            var fieldComponent = $(elem).mogo();
            if (fieldComponent instanceof BooleanGroup) {
              for (var j = 0; j < fieldComponent.groupElements.length; j++) {
                $(fieldComponent.groupElements[j]).on(
                  'focus',
                  $.proxy(this._onFieldFocus, this, elemName)
                );
                $(fieldComponent.groupElements[j]).on(
                  'blur',
                  $.proxy(this._onFieldBlur, this, elemName)
                );
              }
            } else if (fieldComponent instanceof Select) {
              $(fieldComponent.containerDiv).on(
                'enter',
                $.proxy(this._onFieldFocus, this, elemName)
              );
              $(fieldComponent.containerDiv).on(
                'leave',
                $.proxy(this._onFieldBlur, this, elemName)
              );
              $(elem).on('focus', $.proxy(this._onFieldFocus, this, elemName));
              $(elem).on('blur', $.proxy(this._onFieldBlur, this, elemName));
            }
          } else if ($(elem).parents("[data-mogo-ui='Calendar']").length > 0) {
            var calElem = $(elem)
              .parents("[data-mogo-ui='Calendar']")
              .first();
            calElem.on('focus', $.proxy(this._onFieldFocus, this, elemName));
            calElem.on('blur', $.proxy(this._onFieldBlur, this, elemName));
          } else {
            $(elem).on('focus', $.proxy(this._onFieldFocus, this, elemName));
            $(elem).on('blur', $.proxy(this._onFieldBlur, this, elemName));
          }

          // Change handler
          $(elem).on('change', $.proxy(this._onFieldChange, this, elemName));
        }
      }
    }
  };

  this._onSubmitForm = function (evt) {
    if (evt) evt.preventDefault();
    if (this.fieldErrors) return;
    if (!this._initialized) return;

    this._resultObj.submitted = true;
    var data = this._getFormData();
    data = this._sanitizeData(data);
    this.validate(data);

    this._pushToEventMap('submit');

    this.onSubmit(this._resultObj);
  };

  this._onFieldChange = function (associatedFieldName) {
    this.fieldErrors = null;
    this._resultObj._resultObj[associatedFieldName].touched = true;
    this._resultObj._resultObj[associatedFieldName].dirty = true;

    // Validate
    var formData = this._getFormData();
    formData = this._sanitizeData(formData);
    this.validate(formData, [associatedFieldName]);

    this._pushToEventMap('change', associatedFieldName);
    // console.log("change: " + associatedFieldName);
    // console.log("change time: " + new Date().getTime());
  };

  this._onFieldFocus = function (associatedFieldName) {
    this._resultObj._resultObj[associatedFieldName].touched = true;

    this._pushToEventMap('focus', associatedFieldName);
    // console.log("focus: " + associatedFieldName);
    // console.log("focus time: " + new Date().getTime());
  };

  this._onFieldBlur = function (associatedFieldName) {
    this._pushToEventMap('blur', associatedFieldName);
    // console.log("blur: " + associatedFieldName);
    // console.log("blur time: " + new Date().getTime());
  };

  this._getFormData = function () {
    var formData = $(this.node).serializeFormToObj(false);
    var properties = Object.keys(formData);
    for (var i = 0; i < properties.length; i++) {
      formData[properties[i]] = this._retrieveValueFromField(
        properties[i],
        !this.disableTypeConversion
      );
    }

    return formData;
  };

  this._retrieveValueFromField = function (fieldName, coerce) {
    var field = $("[name='" + fieldName + "']", this.node);
    var value;
    if (field.length > 0) {
      var fieldComponent = $(field[0]).mogo();
      if (fieldComponent.declaredClass == 'Checkbox') {
        if (field.length > 1) {
          value = null;
          for (var i = 0; i < field.length; i++) {
            if ( $(field[i]).mogo().val() != null) {
              if (value == null) value = [];
              value[value.length] = $(field[i]).mogo().val();
            }
          }
        } else {
          value = fieldComponent.checked;
        }
      } else if (fieldComponent.declaredClass == 'BooleanGroup' && 
        (fieldComponent.type + '').toLowerCase() === 'array') {
        value = fieldComponent.val() != null ? fieldComponent.val() : '';
      } else if (
        fieldComponent.declaredClass == 'BooleanGroup' &&
        (fieldComponent.type + '').toLowerCase() != 'boolean'
      ) {
        // OK so you're a BooleanGroup with type not boolean
        // ...so just grab the first val and return it as a string.... interesting.
        value = fieldComponent.val() != null ? fieldComponent.val()[0] : '';
      } else if (fieldComponent.declaredClass == 'Radio') {
        if (fieldComponent.groupInstance) {
          value =
            fieldComponent.groupInstance.val() != null ? fieldComponent.groupInstance.val()[0] : '';
        } else value = fieldComponent.val();
      } else if (this._isMogoUIComponent(fieldComponent)) {
        value = fieldComponent.val();
        if (
          value == null &&
          fieldComponent instanceof BooleanGroup &&
          fieldComponent.groupElements.length > 0 &&
          fieldComponent.groupElements[0].type.toLowerCase() == 'radio'
        ) {
          value = '';
        }
      } else {
        field = field[0];
        if (
          field.tagName.toLowerCase() == 'input' &&
          field.type &&
          field.type.toLowerCase() == 'radio' &&
          field.name != null
        ) {
          value = $("[name='" + field.name + "']:checked", this.node).val() || '';
        } else if (
          field.tagName.toLowerCase() == 'input' &&
          field.type &&
          field.type.toLowerCase() == 'checkbox' &&
          field.name != null
        ) {
          if ($("[name='" + fieldName + "']", this.node).length > 1) {
            var checkedCheckboxes = $("[name='" + fieldName + "']:checked", this.node);
            value = null;
            for (var i = 0; i < checkedCheckboxes.length; i++) {
              if (value == null) value = [];
              value[value.length] = checkedCheckboxes[i].value;
            }
          } else {
            value = field.checked;
          }
        } else {
          value = field.value;
        }
      }
    }

    if (coerce && (value === 'true' || value === 'false')) {
      value = value === 'true';
    }

    if (coerce && (value === '' || value === null)) value = undefined;

    return value;
  };

  this._retrieveAjv = function () {
    var filePath = window.mogo.registry.mogoUI.config.resourcePaths.assetsPath + '/mogo-ui-lib-min/js/vendor/ajv.min.js';

    // avoid requesting the script more than once
    if (!window.mogo.registry.mogoUI.config.ajvPromise) {
      window.mogo.registry.mogoUI.config.ajvPromise = $.Deferred();
      $.ajax({
        url: filePath,
        dataType: 'script',
        cache: true,
        complete: window.mogo.registry.mogoUI.config.ajvPromise.resolve.bind(this)
      });
    }

    $.when(window.mogo.registry.mogoUI.config.ajvPromise)
      .then(this._onRetrieveAjv.bind(this));
  };

  this._onRetrieveAjv = function (data) {
    if (data.status === 200) {
      if (this._initialized) this._initSchemaValidation();
    }
  };

  this._onFormAbandonment = function () {
    if (this._resultObj && !(this._resultObj.submitted && this._resultObj.count === 0)) {
      var abandonedFields = [];
      for (var key in this._resultObj._resultObj) {
        if (this._resultObj._resultObj[key].touched) {
          abandonedFields.push({
            name: key,
            position: this._resultObj._resultObj[key].position
          });
        }
      }
      abandonedFields.sort(function (a, b) {
        if (a.position.Y == b.position.Y) {
          return a.position.X - b.position.X;
        } else {
          return a.position.Y - b.position.Y;
        }
      });

      if (abandonedFields.length > 0) {
        this.analytics.forcePushEvent('form-abandoned-schema', {
          FormAbandoned: [abandonedFields]
        });
      }

      // Reset abandoned fields
      for (var key in this._resultObj._resultObj) {
        this._resultObj._resultObj[key].touched = false;
      }
    }
  };

  this._sanitizeData = function (data) {
    for (var field in data) {
      if (
        this.validationObj[field] != null &&
        this.validationObj[field].sanitize &&
        typeof this.validationObj[field].sanitize === 'function'
      ) {
        data[field] = this.validationObj[field].sanitize(data[field]);
      }
    }
    return data;
  };

  this._disableButtons = function () {
    var buttons = $(this.node).find("button, input[type='submit']");
    this._buttonsArr = [];
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].disabled == false) {
        buttons[i].disabled = true;
        this._buttonsArr.push(buttons[i]);
      }
    }
  };

  this._enableButtons = function () {
    for (var i = 0; i < this._buttonsArr.length; i++) {
      this._buttonsArr[i].disabled = false;
    }
  };

  this._ERROR_LABEL_HEIGHT = 270;
  this._$html = $('html');
  this._$body = $('body');
  this._$tray = $('.portal__tray');
  this._$content = $('.portal__content');

  this._scrollTo = function (name) {
    var $elem = $("[name='" + name + "']", this.node);
    if ($elem.length === 0) return;

    this._scrollToElement($elem);
  };

  this._getScrollSpeed = function (elemPos) {
    var time = 500;
    var submitButton = $("input[type='submit'], button[type='submit']", this.node);
    if (submitButton.length === 1) {
      var difference = submitButton.offset().top - elemPos;
      time = difference * 0.65;
    }
    return time;
  };

  this._showErrorLabelForElement = function ($elem) {
    if (this._isMogoUIComponent($elem[0])) {
      $elem.mogo().showErrorLabel();
    }
  };

  this._scrollToElement = function ($elem, elemPos, time) {
    var htmlScrollTop = this._$html.scrollTop(); // mobile
    var bodyScrollTop = this._$body.scrollTop(); // mobile safari
    var trayScrollTop = this._$tray.scrollTop(); // tray visbile
    var contentScrollTop = this._$content.scrollTop();

    var scrollTop = htmlScrollTop;
    var scrollSelector = 'html';
    var elemPos = $elem.offset().top - this._ERROR_LABEL_HEIGHT;
    var position = elemPos;
    if (bodyScrollTop) {
      scrollSelector = 'body';
      scrollTop = bodyScrollTop;
    } else if (trayScrollTop) {
      scrollSelector = '.portal__tray';
      scrollTop = trayScrollTop;
      position += scrollTop;
    } else if (contentScrollTop) {
      scrollSelector = '.portal__content';
      scrollTop = contentScrollTop;
      position += scrollTop;
    }

    if (scrollTop <= elemPos) {
      // already visbile
      this._showErrorLabelForElement($elem);
      return;
    }

    $(scrollSelector).animate(
      {scrollTop: position + 'px'},
      {
        duration: this._getScrollSpeed(elemPos),
        complete: this._showErrorLabelForElement.bind(this, $elem)
      }
    );
  };

  this._isMogoUIComponent = function (field) {
    if (field == null) return false;

    if (typeof field === 'string' && $("[name='" + field + "']", this.node).length > 0) {
      return typeof $("[name='" + field + "']", this.node).mogo().create !== 'function';
    } else {
      if (field instanceof HTMLElement && typeof $(field).mogo().create !== 'function') {
        return true;
      } else if (
        field instanceof jQuery &&
        field.length == 1 &&
        typeof $(field[0]).mogo().create !== 'function'
      ) {
        return true;
      } else if (typeof field.create !== 'function' && field.declaredClass) {
        return true;
      }
    }
    return false;
  };

  this._getPosition = function (fieldInst) {
    var position = {};
    if (typeof $(fieldInst).mogo().containerDiv !== 'undefined') {
      position = $($(fieldInst).mogo().containerDiv).offset();
    } else position = $(fieldInst).offset();
    return {X: position.left, Y: position.top};
  };

  this.destroy = function () {
    $(window).off('beforeunload.validation');
    this._onFormAbandonment();
  };
}
